import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

export const getUserApiTokens = reatomAsync(async () => {
  return API.tokenApi.apiTokenControllerGetApiTokens().then((d) => d.data);
}, "getUserApiTokens").pipe(withDataAtom(null), withIsLoadingAtom());
